const scriptEl = document.currentScript as HTMLScriptElement | null;

/**
 * The `?dpaId` flag was introduced for VSB integration.
 * It is used to determine if the DPA ID is present in the URL. if present, it will be used for SDK initialization.
 */
//START GENAI@GHCOPILOT
//prettier-ignore
//export const queryParam = scriptEl?.src.includes('?dpaId') ? scriptEl.src.split('?dpaId=')[1] : null;
const emptyStr = ''; // Needed for the locale query parameter else MP request fails
//START GENAI@GHCOPILOT
let constructQP = scriptEl?.src.includes('?dpaId') ? scriptEl.src.split('?dpaId=')[1] : null;

if (constructQP && !constructQP.includes('locale=')) {
  constructQP += `&locale=${emptyStr}`;
}

//START GENAI@GHCOPILOT

if (constructQP && !constructQP.includes('cardBrands=')) {
  constructQP += `&cardBrands=${emptyStr}`;
}
//END GENAI@GHCOPILOT
// END GENAI@GHCOPILOT

export const queryParam = constructQP;
// END GENAI@GHCOPILOT
export const isDpaIdPresent = scriptEl?.src.includes('?dpaId');

let dpaId: string | null = null;
let locale: string | null = null;
let cardBrands: string[] | null = null;

if (queryParam) {
  const qs = scriptEl?.src.split('?')[1];
  qs?.split('&').forEach(kvp => {
    const [key, value] = kvp.split('=');
    switch (key) {
      case 'dpaId':
        dpaId = value;
        break;
      case 'locale':
        locale = value;
        break;
      case 'cardBrands':
        cardBrands = value.split(',');
        break;
    }
  });
}

export { dpaId, locale, cardBrands };
